// extracted by mini-css-extract-plugin
module.exports = {"main":"LoadingModal_main__cD_w5","message":"LoadingModal_message__RHWnP"};